// extracted by mini-css-extract-plugin
module.exports = {"note":"FileAction_note__oSK8f"};